import { BASIC_INITIAL_STATE, CommonHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

import Constants from '../../utils/Constants';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const getEvents = (state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    let newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const url = `/Event`;
    CommonHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          const arrayDataCopy = JSON.parse(JSON.stringify(arrayData));
          arrayDataCopy.unshift({ eventId: Constants.DEFAULT_ID, eventName: '--' });
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            items: arrayData.map(x => { return { id: x.eventId, name: x.eventName }; }),
            itemsForDropdown: arrayDataCopy.map(x => { return { id: x.eventId, name: x.eventName }; }),
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

const EventData = { INITIAL_STATE, getEvents };
export default EventData;

